import React from "react";
import "./HomeLeft.css";

function HomeLeft() {
  return (
    <div className="homeleft">
      <div className="homeleft__img">
        <img
          alt=""
          src="https://images.unsplash.com/photo-1562774053-701939374585?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=764&q=80"
        />
      </div>
      <div className="homeleft__datas">
        <h1>Introduction</h1>
        <p>
          ○ GBPEC draws on a reserve of extraordinary talent as a by-product of
          its selective, stringent and consequently, amazingly successful to all
          the UG programmes
        </p>
        <p>
          ○ The quality of students coming in is, without doubt, the best in the
          world- drilled in the sciences and problem-solving, the successful
          candidates are, by default, gifted, dedicated, hard working and
          blessed with analytical ability. While each one is a ‘topper’, in
          his/her own right, a leader in more than one sphere of activity, many
          are consistent toppers at the National Level with various prestigious
          scholarships and awards and a few even have proved their mettle at the
          international level, having represented the nation at International
          Olympiads and other Fairs, Seminars etc.
        </p>
        <p>
          ○ The pool of talent thus uncovered embraces the best and the
          brightest from across the length and breadth of the nation. People
          from the most diverse backgrounds come together in their quest to
          extend the frontiers of scientific and technological knowledge and in
          the process forge life-long friendships and inculcate the spirit of
          teamwork and dedication, which gives them a head start in terms of
          their careers in the distant corners of the globe.
        </p>
        <p>
          ○ The pool of talent thus uncovered embraces the best and the
          brightest from across the length and breadth of the nation. People
          from the most diverse backgrounds come together in their quest to
          extend the frontiers of scientific and technological knowledge and in
          the process forge life-long friendships and inculcate the spirit of
          teamwork and dedication, which gives them a head start in terms of
          their careers in the distant corners of the globe.
        </p>

        {/* next */}

        <h1>From Principal Desk</h1>
        <p className="font">
          It is indeed a great pleasure for me to mark the presence of Govind
          Ballabh Pant Engineering College (GBPEC) in the highly competitive
          world. It is a matter of immense pride that GBPEC continues to be one
          of the highly sought after institutions affiliated to the Guru Gobind
          Singh Indraprashta University (GGSIPU) for admissions to engineering
          and technology programs. We recognize that the fast growing
          technological developments in all fields are challenging and industry
          requires multi-skilled talent. We have attempted to successfully adapt
          ourselves to this challenge with the active support of the Govt. of
          Delhi incorporating modern infrastructural facilities to craft
          "engineers of tomorrow", with a culture of high sense of dedication,
          determination, discipline and passion. At GBPEC, we believe that the
          sequence of activities must have a positive impact on our students'
          academic and personal development and we are engaged in providing to
          the industry with engineers who would have capabilities to participate
          in the ongoing technological revolution with ease and speed, as well
          as with professionalism and moral values.
        </p>
        <div className="auth">
          <p>
            ❝At this fast evolving institute, our focus is on providing an
            ambience conducive to developing a career rather than to just
            getting a job. I am delighted to inform you that, the college has
            earned its place amongst the upcoming institutes of excellence of
            Delhi, with a potential to develop into a world-class centre of
            higher technical education over the coming years. I wish all my
            students, a great success in all their endeavours❞
          </p>
          <img
            alt=""
            src="https://vishal2612200.github.io/college-website-design/images/home/home1.jpg"
          />
        </div>
        <div className="font1">
          <p>
            G B Pant Engineering College was established by the Govt. of NCT of
            Delhi in the year 2007 with the aim of imparting quality technical
            education for the students of Delhi and nearby areas. Since its
            inception, the faculty and staff have been tirelessly working
            towards the growth of the institution.
          </p>
        </div>
        <div className="leftimages">
          <div className="leftimages1">
            <img
              alt=""
              src="https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8Y29sbGVnZXxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80"
            />
          </div>
          <div className="left__">
            <p>👉 Quality Education.</p>
            <p>👉 Modern labs facilities.</p>
            <p>👉 Highly Qualified Teachers.</p>
            <p>👉 Supportive seniors.</p>
            <p>👉 Different fest and Socities.</p>
            <p>👉 Positive growth rate.</p>
            <p>👉 Government Institution.</p>
          </div>
        </div>
      </div>

      <div className="placements">
        <h1>PLACEMENTS</h1>
      </div>
    </div>
  );
}

export default HomeLeft;
